import type { ArticleMeta } from './types.ts';

const metaModules = import.meta.glob<ArticleMeta>('./*/meta.ts', {
  eager: true,
  import: 'articleMeta',
});

const articles = Object.values(metaModules).sort((a, b) =>
  b.publishedAt.localeCompare(a.publishedAt),
);

export const getAllTags = (): string[] => {
  const tags = new Set<string>();
  for (const meta of articles) {
    for (const tag of meta.tags) {
      tags.add(tag);
    }
  }
  return [...tags].sort((a, b) => a.localeCompare(b, 'nb'));
};

export const getArticles = (filter?: { tag?: string }): ArticleMeta[] => {
  if (!filter?.tag) {
    return articles;
  }
  return articles.filter((meta) => meta.tags.includes(filter.tag!));
};
